import { buildEmailsGroupPath } from '@/lib/emails/emails-route'

export type EmailCanvasFocusMode = 'default' | 'create'

/**
 * Canonical email-canvas deep link. `emailIds` is durable selection;
 * `focusEmailIds` is the one-shot camera command that the canvas clears after
 * landing. Newly created emails opt into the wider creation framing policy.
 */
export function buildFocusedEmailCanvasUrl(
  emailId: string,
  focusMode: EmailCanvasFocusMode = 'default',
  groupSegment?: string
): string {
  const encoded = encodeURIComponent(emailId)
  const mode = focusMode === 'create' ? '&focusMode=create' : ''
  // Unknown membership uses the point resolver, which never loads the grid.
  const path = groupSegment
    ? buildEmailsGroupPath(groupSegment)
    : `/emails/${encoded}`
  return `${path}?emailIds=${encoded}&focusEmailIds=${encoded}${mode}`
}
